export const generateURLByParts = (route: string, urlParts: Record<string, number | string>) => {
  let changedRoute = route;

  for (const [key, value] of Object.entries(urlParts)) {
    changedRoute = changedRoute.replace(`:${key}`, `${value}`);
  }

  return changedRoute;
};

export const URLServices = {
  generateURLByOrigin: (path: string) => (typeof window !== "undefined" ? window.location.origin + path : ""),
  routerPath: (path: string) => path,
  generateNextImageUrl: (imageUrl: string, width: number) => `/next-app/_next/image?url=${imageUrl}&w=${width}&q=90`,
};
